import comp from "./ReadReceipt";
export default comp;
